import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Descriptions, Row, Space, Spin, Table, Typography } from "antd";
import EmailSenderModal from "./EmailSenderModal";
import CommunicationCategoryType from "../../../enums/CommunicationCategoryType";
import { EditOutlined, RestOutlined } from "@ant-design/icons";
import TenantEmailSettingsResource from "../../../api/tenant/TenantEmailSettingsResource";
import { axiosErrorHandler } from "../../../../../swzutils";
const { Text } = Typography;
const TabEmail = (props) => {
    const [loading, setLoading] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [emailSettings, setEmailSettings] = useState();
    const [editCommunicationCategory, setEditCommunicationCategory] = useState(CommunicationCategoryType.DEFAULT);
    const [editSender, setEditSender] = useState(null);
    useEffect(() => {
        loadEmailSenders();
    }, []);
    const loadEmailSenders = () => {
        setLoading(true);
        TenantEmailSettingsResource.fetchEmailSettings(props.tenantId, (response) => setEmailSettings(response), axiosErrorHandler, () => setLoading(false));
    };
    const onClickEditDefaultSender = () => {
        setEditSender(emailSettings?.defaultSender);
        setEditCommunicationCategory(CommunicationCategoryType.DEFAULT);
        setShowEditModal(true);
    };
    const onClickEditEmailSender = (record) => {
        if (record.useDefault) {
            // populate modal with default values initially
            setEditSender(emailSettings.defaultSender);
        }
        else {
            setEditSender(record);
        }
        setEditCommunicationCategory(CommunicationCategoryType.fromString(record.communicationCategory));
        setShowEditModal(true);
    };
    const onClickUseDefault = (record) => {
        TenantEmailSettingsResource.deleteEmailSender(props.tenantId, CommunicationCategoryType.fromString(record.communicationCategory), axiosErrorHandler, () => {
            loadEmailSenders();
        });
    };
    const columns = [
        {
            title: 'Communication Category',
            dataIndex: 'communicationCategory',
            render: (txt, value) => {
                return CommunicationCategoryType.fromString(txt)?.description || txt;
            }
        },
        {
            title: 'From Name',
            dataIndex: 'fromName',
            render: (value, record, index) => {
                if (record.useDefault) {
                    return _jsx(Text, { type: "secondary", disabled: true, children: emailSettings?.defaultSender?.fromName });
                }
                return record.fromName;
            }
        },
        {
            title: 'Reply To Name',
            dataIndex: 'replyToName',
            render: (value, record, index) => {
                if (record.useDefault) {
                    return _jsx(Text, { type: "secondary", disabled: true, children: emailSettings?.defaultSender?.replyToName });
                }
                return record.replyToName;
            }
        },
        {
            title: 'Reply To Address',
            dataIndex: 'replyToAddress',
            render: (value, record, index) => {
                if (record.useDefault) {
                    return _jsx(Text, { type: "secondary", disabled: true, children: emailSettings?.defaultSender?.replyToAddress });
                }
                return record.replyToAddress;
            }
        },
        {
            title: 'Action',
            render: (value, record, index) => {
                return (_jsxs(_Fragment, { children: [_jsx(Button, { icon: _jsx(EditOutlined, {}), onClick: () => onClickEditEmailSender(record), children: "Edit" }), "\u00A0", _jsx(Button, { icon: _jsx(RestOutlined, {}), onClick: () => onClickUseDefault(record), disabled: record.useDefault, children: "Use Default" })] }));
            }
        }
    ];
    return (_jsxs(_Fragment, { children: [_jsx(Spin, { spinning: loading, children: _jsxs(Space, { orientation: "vertical", size: "middle", style: { display: 'flex' }, children: [_jsx(Row, { children: _jsx(Col, { md: 24, children: _jsxs(Card, { title: "Default Sender", type: "inner", variant: 'borderless', children: [_jsxs(Descriptions, { children: [_jsx(Descriptions.Item, { label: "From Name", children: emailSettings?.defaultSender?.fromName }), _jsx(Descriptions.Item, { label: "Reply to Name", children: emailSettings?.defaultSender?.replyToName }), _jsx(Descriptions.Item, { label: "Reply to Email", children: emailSettings?.defaultSender?.replyToAddress })] }), _jsx(Button, { onClick: onClickEditDefaultSender, className: "pull-right", children: "Edit" })] }) }) }), _jsx(Row, { children: _jsx(Col, { md: 24, children: _jsx(Card, { title: "Sender Overrides", type: "inner", variant: 'borderless', children: _jsx(Table, { columns: columns, dataSource: emailSettings?.senders }) }) }) })] }) }), _jsx(EmailSenderModal, { open: showEditModal, onUpdated: (updated) => {
                    loadEmailSenders();
                    setShowEditModal(false);
                }, onCancel: () => {
                    setShowEditModal(false);
                }, tenantId: props.tenantId, communicationCategory: editCommunicationCategory, sender: editSender })] }));
};
export default TabEmail;
